import React from 'react';
import { PrivacyHeader } from '../components/PrivacyHeader';
import { PolicySection } from '../components/PolicySection';
import { PolicyFooter } from '../components/PolicyFooter';
export function PrivacyPolicy() {
  return <div className="w-full min-h-screen bg-[#f7f4ec] flex flex-col" data-id="element-20">
      <PrivacyHeader data-id="element-21" />

      <main className="flex-1 max-w-3xl w-full mx-auto px-6 py-12 sm:py-16" data-id="element-22">
        <div className="text-center mb-12" data-id="element-23">
          <p className="text-xs uppercase tracking-[0.3em] text-[#2a8a8f] mb-3" data-id="element-24">
            Última actualización · Mayo 2026
          </p>
          <h1 className="font-serif-display text-4xl sm:text-5xl text-[#0f3f4a] leading-tight" data-id="element-25">
            Política de Privacidad
          </h1>
          <div className="w-16 h-px bg-[#2a8a8f] mx-auto mt-6" aria-hidden="true" data-id="element-26" />
        </div>

        <p className="text-base sm:text-lg leading-relaxed text-[#0f3f4a]/85 mb-12 text-center font-light italic" data-id="element-27">
          En La Conexión Cuántica valoramos y protegemos la privacidad de todas
          las personas que visitan nuestro sitio web, se comunican con nosotros
          o utilizan nuestros servicios de facilitación de salud y bienestar. La
          presente política explica cómo recopilamos, utilizamos y protegemos tu
          información personal.
        </p>

        <PolicySection title="Información que recopilamos" data-id="element-28">
          <p data-id="element-29">
            Podemos recopilar los siguientes datos personales cuando completas
            formularios, solicitas información o te contactas con nosotros:
          </p>
          <ul className="list-disc list-outside ml-5 space-y-1.5" data-id="element-30">
            <li data-id="element-31">Nombre y apellido</li>
            <li data-id="element-32">Número de teléfono</li>
            <li data-id="element-33">Dirección de correo electrónico</li>
            <li data-id="element-34">
              Información compartida voluntariamente relacionada con consultas o
              sesiones
            </li>
            <li data-id="element-35">
              Datos de navegación y uso del sitio web (cookies, IP, navegador y
              comportamiento de navegación)
            </li>
          </ul>
          <p data-id="element-36">
            La información es brindada voluntariamente por el usuario al
            comunicarse con nosotros.
          </p>
        </PolicySection>

        <PolicySection title="Cómo utilizamos tu información" data-id="element-37">
          <p data-id="element-38">La información recopilada puede utilizarse para:</p>
          <ul className="list-disc list-outside ml-5 space-y-1.5" data-id="element-39">
            <li data-id="element-40">Responder consultas y solicitudes de contacto</li>
            <li data-id="element-41">Coordinar y gestionar sesiones o servicios solicitados</li>
            <li data-id="element-42">
              Enviar información relacionada con nuestros servicios, novedades o
              contenidos de bienestar
            </li>
            <li data-id="element-43">
              Mejorar la experiencia del usuario y el funcionamiento del sitio
              web
            </li>
            <li data-id="element-44">Cumplir obligaciones legales o de seguridad</li>
          </ul>
          <p className="font-medium text-[#0f3f4a]" data-id="element-45">
            No vendemos, alquilamos ni comercializamos tus datos personales.
          </p>
        </PolicySection>

        <PolicySection title="Confidencialidad y protección de datos" data-id="element-46">
          <p data-id="element-47">
            La Conexión Cuántica implementa medidas razonables de seguridad para
            proteger la información personal frente a accesos no autorizados,
            alteraciones o divulgaciones indebidas.
          </p>
          <p data-id="element-48">
            Toda información compartida durante consultas o comunicaciones será
            tratada con respeto y confidencialidad.
          </p>
        </PolicySection>

        <PolicySection title="Uso de cookies y tecnologías de seguimiento" data-id="element-49">
          <p data-id="element-50">
            Nuestro sitio puede utilizar cookies y herramientas de análisis para
            comprender cómo navegan los usuarios y mejorar nuestros servicios.
            Estas herramientas pueden recopilar datos anónimos de navegación y
            comportamiento.
          </p>
          <p data-id="element-51">
            El usuario puede configurar su navegador para rechazar cookies,
            aunque algunas funciones del sitio podrían verse afectadas.
          </p>
        </PolicySection>

        <PolicySection title="Publicidad y plataformas de terceros" data-id="element-52">
          <p data-id="element-53">
            Podemos utilizar servicios de terceros como Meta (Facebook,
            Instagram), WhatsApp Business, Google y otras herramientas digitales
            para campañas publicitarias, comunicación y análisis de tráfico.
            Estas plataformas pueden recopilar determinados datos conforme a sus
            propias políticas de privacidad.
          </p>
          <p data-id="element-54">
            Al interactuar con nuestros anuncios o canales de contacto, el
            usuario acepta que dichas plataformas procesen información bajo sus
            condiciones correspondientes.
          </p>
        </PolicySection>

        <PolicySection title="WhatsApp y medios de contacto" data-id="element-55">
          <p data-id="element-56">
            Cuando te contactás con La Conexión Cuántica mediante WhatsApp,
            correo electrónico o formularios, autorizás el uso de esa
            información exclusivamente para responder tu consulta, brindar
            información solicitada y coordinar servicios relacionados.
          </p>
          <p data-id="element-57">No se enviará spam ni comunicaciones no solicitadas.</p>
          <p data-id="element-58">Podés solicitar dejar de recibir mensajes en cualquier momento.</p>
        </PolicySection>

        <PolicySection title="Sobre nuestros servicios" data-id="element-59">
          <p data-id="element-60">
            La Conexión Cuántica brinda servicios de facilitación de salud y
            bienestar y acompañamiento orientado al desarrollo personal mediante
            herramientas y metodologías de trabajo subconsciente.
          </p>
          <div className="border-l-2 border-[#2a8a8f] pl-4 py-1 bg-[#b8d8d8]/20 rounded-r" data-id="element-61">
            <p data-id="element-62">
              Nuestros servicios{' '}
              <span className="font-medium" data-id="element-63">no reemplazan</span> atención
              médica, psicológica, psiquiátrica ni tratamientos profesionales de
              la salud. Ante cualquier condición médica o de salud, recomendamos
              consultar con profesionales habilitados.
            </p>
          </div>
        </PolicySection>

        <PolicySection title="Derechos del usuario" data-id="element-64">
          <p data-id="element-65">Podés solicitar en cualquier momento:</p>
          <ul className="list-disc list-outside ml-5 space-y-1.5" data-id="element-66">
            <li data-id="element-67">Acceder a tus datos personales</li>
            <li data-id="element-68">Corregir información inexacta</li>
            <li data-id="element-69">Solicitar la eliminación de tus datos</li>
            <li data-id="element-70">Retirar tu consentimiento para comunicaciones futuras</li>
          </ul>
          <p data-id="element-71">
            Para ejercer estos derechos podés escribirnos a{' '}
            <a href="mailto:laconexioncuantica2022@gmail.com" className="text-[#2a8a8f] underline underline-offset-2 hover:text-[#0f3f4a] transition-colors font-medium" data-id="element-72">
              laconexioncuantica2022@gmail.com
            </a>
            .
          </p>
        </PolicySection>

        <PolicySection title="Modificaciones" data-id="element-73">
          <p data-id="element-74">
            La Conexión Cuántica podrá actualizar esta Política de Privacidad
            cuando resulte necesario para reflejar cambios legales, técnicos o
            de funcionamiento del sitio. Las modificaciones entrarán en vigencia
            desde su publicación.
          </p>
        </PolicySection>

        <div className="mt-16 pt-8 border-t border-[#0f3f4a]/15 text-center" data-id="element-75">
          <p className="text-sm text-[#0f3f4a]/70 italic" data-id="element-76">
            Al utilizar este sitio web o comunicarte con nosotros, aceptás los
            términos de esta Política de Privacidad.
          </p>
        </div>
      </main>

      <PolicyFooter data-id="element-77" />
    </div>;
}